var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Star 5",
    d: "M8.45652 1.1012C8.67883 0.650751 9.32116 0.650751 9.54347 1.1012L11.7979 5.66919C11.8862 5.84807 12.0568 5.97205 12.2542 6.00073L17.2953 6.73324C17.7924 6.80548 17.9909 7.41637 17.6312 7.767L13.9834 11.3227C13.8406 11.4619 13.7754 11.6625 13.8091 11.8591L14.6703 16.8798C14.7552 17.3749 14.2355 17.7525 13.7909 17.5187L9.28202 15.1483C9.10546 15.0554 8.89453 15.0554 8.71797 15.1483L4.2091 17.5187C3.76448 17.7525 3.24482 17.3749 3.32974 16.8798L4.19085 11.8591C4.22457 11.6625 4.15939 11.4619 4.01655 11.3227L0.368798 7.767C0.0090909 7.41637 0.207582 6.80548 0.704685 6.73324L5.74576 6.00073C5.94316 5.97205 6.1138 5.84807 6.20209 5.66919L8.45652 1.1012Z",
    fill: "#FEC004"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGStar);
export default __webpack_public_path__ + "static/media/g-star.dff79bd31a6f9ee66c8066d744ab3533.svg";
export { ForwardRef as ReactComponent };